<template>
  <div>
    <Category class="block md:hidden" />
    <div class="mt-4 flex flex-row mx-4">
      <div
        :class="[
          'flex w-1/2 lg:2/3 justify-begin text-3xl flex-col',
          theme.body.textColor,
        ]"
      >
        <div v-trans:name="selectedMenuCategory"></div>
        <div class="text-xs" v-trans:description="selectedMenuCategory"></div>
      </div>
      <div class="flex w-1/2 lg:1/3 justify-end items-center">
        <Language /><DisplayMode class="ml-2" />
      </div>
    </div>

    <div class="flex content-center flex-wrap px-4">
      <div
        v-for="(menuCategory, index) in menuSubCategories"
        v-bind:key="menuCategory.id"
        :class="[isListDisplayed ? 'w-full' : 'w-1/2']"
        @click="getCategories(menuCategory)"
      >
        <div class="flex flex-col">
          <div
            :class="[
              'cursor-pointer flex justify-center h-24 rounded items-center my-2 rounded-large shadow-lg transition duration-500  hover:shadow-xl',
              isListDisplayed
                ? ''
                : index % 2 == 0
                ? 'mr-2 flex-col'
                : 'ml-2 flex-col',
              theme.body.backgroundColor,
              'text-' + theme.body.primaryColor,
            ]"
          >
            <div
              :class="[
                'flex items-center w-full',
                menuCategory.picture_url ? 'justify-end' : 'justify-center',
                isListDisplayed ? 'flex-row' : 'flex-col',
              ]"
            >
              <div
                v-if="menuCategory.picture_url"
                class="w-1/2 justify-center flex items-center"
              >
                <div
                  class="h-16 w-24 rounded-lg overflow-hidden flex items-center"
                >
                  <img
                    v-if="menuCategory.picture_url"
                    :src="menuCategory.picture_url"
                    alt
                    class="object-fill rounded-lg"
                  />
                </div>
              </div>
              <div
                :class="[
                  theme.body.textColor,
                  isListDisplayed
                    ? menuCategory.picture_url
                      ? 'w-1/2'
                      : ''
                    : '',
                ]"
                v-trans:name="menuCategory"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import lang from "../lang.js";
import Language from "../views/Language";
import DisplayMode from "../views/DisplayMode";
import Category from "../views/Category";
export default {
  data() {
    return {
      lang: lang,
    };
  },
  components: { DisplayMode, Category, Language },
  computed: {
    ...mapGetters([
      "menuSubCategories",
      "theme",
      "language",
      "isCartViewShown",
      "isListDisplayed",
      "selectedMenuCategory",
      "parentSelectedMenuCategory",
      "isSubSubCategory",
    ]),
  },
  methods: {
    getCategories(item) {
      this.$store.commit("updateCategoryId", item.Id);
      if (item.hasSubCategories) {
        this.$store.commit(
          "updateSubCategoryId",
          this.$route.params.subCategoryId
        );
        this.$store.dispatch("GET_MENU_SUB_CATEGORIES");
        this.$store.commit("updateMenuCategoriesCategories", item);

        this.$router.push(
          "/" +
            this.$route.params.menuHash +
            "/category/" +
            this.$route.params.subCategoryId
        ).catch(()=>{});
      } else {
        this.$store.dispatch("GET_CATEGORY");
        this.$store.commit("updateIsSubSubCategory", true);
        this.$router.push(
          "/" +
            this.$route.params.menuHash +
            "/sub/category/" +
            this.$route.params.categoryId
        ).catch(()=>{});
      }
    },
  },
  mounted (){
    if(this.$route.name == "CategoryCategory") {
      this.$store.commit("updateSelectedMenuCategory", this.parentSelectedMenuCategory);
    }
  }
};
</script>

<style>
</style>